// extracted by mini-css-extract-plugin
export default {"container":"SymbolField_container__nuL3P"};